import { render } from "./VideoLesson.vue?vue&type=template&id=10ba7889&scoped=true"
import script from "./VideoLesson.vue?vue&type=script&lang=js"
export * from "./VideoLesson.vue?vue&type=script&lang=js"

import "./VideoLesson.vue?vue&type=style&index=0&id=10ba7889&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-10ba7889"

export default script